import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { Pool } from './pool.interface';

export class PoolService {
   async getPools(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<Pool>>>(`/nxtplan/pools`, {
         params: { ...query, 'filter[search]': (query.search as string) || '', search: undefined },
      });
      return response.data;
   }

   async getPool() {
      throw Error('Method not implemented');
   }

   async postCandidatePool(poolId: number, candidateIds: Array<number>) {
      const response = await http.post(`/nxtplan/pools/${poolId}/add-candidates`, { candidate_ids: candidateIds });
      return response.data;
   }

   async putPool() {
      throw Error('Method not implemented');
   }

   async deletePool() {
      throw Error('Method not implemented');
   }
}
